import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { AngularFireAuth } from "angularfire2/auth";
import {
  AngularFirestore,
  AngularFirestoreDocument
} from "angularfire2/firestore";
//import firebase from "firebase/app";

import { Observable, of } from "rxjs";
import { switchMap, first } from "rxjs/operators";
import { FirebaseAuth } from "angularfire2";

interface User {
  uid: string;
  email: string;
  photoURL?: string;
  displayName?: string;
  favoriteColor?: string;
}


@Injectable()
export class AuthProvider {
  user: Observable<any>;

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private platform: Platform
  ) {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.afs.doc<any>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    );
  }

  async emailLogin(email: string, password: string) {
    try {
      return await this.afAuth.auth.signInWithEmailAndPassword(email, password)
      // .then(async (credential) => {
      //   await this.updateUserData(credential.user);
      // })
    } catch (err) {
      throw new Error(err);
    }
  }

  // async emailSignUp(email: string, password: string, userdata: any) {
  //   try {

      
  //     await this.afAuth.auth.createUserAndRetrieveDataWithEmailAndPassword(email, password).then(async (data: any) => {
  //       let userdata = {};
  //       userdata['kentest'] = 'test'
  //       console.log("user: ", data.user);
  //       return await this.updateUserData(data.user, userdata);
  //     })
  //     .catch(error => console.log(error));
  //   }
  //   catch(err)  {
  //     console.log(err);
  //   }

  // }

  async sendPasswordResetEmail(email: string) {
    try {
      return await this.afAuth.auth.sendPasswordResetEmail(email)
    } catch (err) {
      throw new Error(err);
    }
  }

  getUserToken()  {
    return new Promise((resolve, reject) => {
    this.afAuth.auth.currentUser.getIdToken().then((token) => { 
      resolve(token);
    })
    .catch((error) => {
      reject(error);
    });
  });
  }


  //// FACEBOOK ////
  /*
  async facebookLogin() {
    if (this.platform.is("cordova")) {
      return await this.nativeFacebookLogin();
    } else {
      return await this.webFacebookLogin();
    }
  }

  async nativeFacebookLogin(): Promise<void> {
    try {
      const response = await this.facebook.login(["email", "public_profile"]);
      const facebookCredential = firebase.auth.FacebookAuthProvider.credential(
        response.authResponse.accessToken
      );

      const firebaseUser = await firebase
        .auth()
        .signInWithCredential(facebookCredential);

      return await this.updateUserData(firebaseUser);
    } catch (err) {
      console.log(err);
    }
  }

  async webFacebookLogin(): Promise<void> {
    try {
      const provider = new firebase.auth.FacebookAuthProvider();
      const credential = await this.afAuth.auth.signInWithPopup(provider);

      return await this.updateUserData(credential.user);
    } catch (err) {
      console.log(err);
    }
  }
  */
   // Save custom user data in Firestore
   async updateCustomUserData(data) {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          const userRef: AngularFirestoreDocument<any> = this.afs.doc(
            `users/${user.uid}`
          );
            
          return userRef.set(data, { merge: true });
        }
      })
    );


  }
  

  // Save custom user data in Firestore
  private async updateUserData(user: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);

    const data: User = {
      uid: user.uid,
      email: user.email
    }

    return await userRef.set(data, { merge: true });
  }


  //// HELPERS ////

  async logout(): Promise<any> {
    return this.afAuth.auth.signOut();
  }

  // Current user as a Promise. Useful for one-off operations.
  async getCurrentUser(): Promise<any> {
    return this.user.pipe(first()).toPromise();
  }

  // Current user as boolean Promise. Used in router guards
  async isLoggedIn(): Promise<boolean> {
    const user = await this.getCurrentUser();
    return !!user;
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts